import bundleHandler from './bundle-handler.js';
import bundleSellsHandler from './bundle-sells-handler.js';

export const handlers = [bundleHandler, bundleSellsHandler];
